import {view} from '@sail/ui';
import {
  Conversation,
  InlineDataResult as ConversationsClientInlineDataResult,
  InlineDataResultAction,
  InlineDataMessage as InlineDataMessageType,
} from '@stripe-internal/conversations-client';
import {
  InlineDataComponent,
  InlineDataProps,
  InlineDataResult,
} from '@stripe-internal/inline-data';
import {useNewUniversalHelpDesign} from '../../../FeatureFlagsProvider';

type Props = {
  conversation: Conversation;
  message: InlineDataMessageType;
};

export const InlineDataMessage = ({conversation, message}: Props) => {
  const inlineData = message.inlineData as InlineDataProps;
  const useNewDesign = useNewUniversalHelpDesign();

  // The Stripe Assistant flow should never be hitting this component,
  // but let's make this safe just in case
  if (inlineData.name === 'stripe_assistant') {
    return null;
  }

  const onDone = (result: InlineDataResult) => {
    const action: InlineDataResultAction = {
      name: 'inline-data-result',
      message,
      result: result as ConversationsClientInlineDataResult,
    };
    conversation.action(action);
  };

  const inlineDataProps: InlineDataProps = {
    ...inlineData,
    context: inlineData.context ?? {
      conversation_id: conversation.id,
      effect_id: message.effectId,
    },
    onDone,
  };

  return (
    <view.div
      data-testid="inline-data-message"
      css={useNewDesign ? {marginTop: 'medium'} : {}}
    >
      <InlineDataComponent {...inlineDataProps} />
    </view.div>
  );
};
